import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import BrandsMarqueSection from "../../../common/BrandsMarqueSection";
import Cursor from "../../../common/Cursor";
import Footer from "../../../common/Footer";
import Header from "../../../common/Header";
import Loader from "../../../common/Loader";
import ProgressCircle from "../../../common/ProgressCircle";
import TextMarqueSection from "../../../common/TextMarqueSection";
import { fetchData, toAbsoluteMedia } from "../../../api/api";

// helpers
function stripHtml(html = "") {
  const el = document.createElement("div");
  el.innerHTML = html;
  return (el.textContent || el.innerText || "").trim();
}
function truncate(text = "", max = 180) {
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  const sp = cut.lastIndexOf(" ");
  return (sp > 0 ? cut.slice(0, sp) : cut) + "…";
}

const BlogSeven = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setErr("");
      try {
        const raw = await fetchData("/blog/blogs/"); // trailing slash matters
        console.log("BLOG RAW DATA:", raw); // 👈 full API payload

        const data = Array.isArray(raw) ? raw : raw?.results || [];

        const mapped = data.map((b, idx) => {
          // log each slug as it comes from API
          console.log(`BLOG[${idx}] SLUG:`, b?.slug);
          const item = {
            slug: b?.slug ? String(b.slug) : "",
            title: b.title || "",
            author: b.author || "",
            category: b?.category?.name || "",
            date: b.created_at ? new Date(b.created_at) : null,
            image: toAbsoluteMedia(b.image || ""),
            excerpt: truncate(stripHtml(b.description || ""), 200),
          };
          if (!item.slug) console.warn("Blog item missing slug:", b);
          return item;
        });

        // only keep posts with a valid slug
        const withSlug = mapped.filter((x) => !!x.slug);

        // sort newest first (if date), else by title
        withSlug.sort((a, b) => {
          if (a.date && b.date) return b.date - a.date;
          return a.title.localeCompare(b.title);
        });

        if (alive) setPosts(withSlug);
      } catch (e) {
        if (alive) setErr("Failed to load blogs.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <>
      <Helmet>
        <title>Blog | Marichi Tech AI</title>
        <meta name="description" content="Read the latest blogs, trends, and tips in technology and innovation." />
        <meta name="keywords" content="Tech blog, software development blogs, IT trends" />
        <meta property="og:title" content="Blog | Marichi Tech AI" />
        <meta property="og:description" content="Stay updated with articles and tutorials from our tech experts." />
      </Helmet>

      {loading && <Loader />}
      <div className="site_contain">
        <Cursor />
        <Header />

        {/* Blog Header */}
        <section className="single-blog2-section-main overflow-hidden" id="main">
          <div className="container">
            <p className="main-text" data-aos="fade-down">NEWS</p>
            <h1 className="JessicaBiogi blog2-main-text" data-aos="fade-down">Latest Blog</h1>
            <nav aria-label="breadcrumb" id="breadcrumb" data-aos="fade-up">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/blog">Blog</Link></li>
              </ol>
            </nav>
          </div>
        </section>

        {/* Blog List */}
        <section className="list-blog">
          <div className="container">
            <h2 className="d-none">hidden</h2>

            {!loading && err && <p style={{ color: "red" }}>{err}</p>}

            {!loading && !err && posts.map((blog, i) => (
              <div className="list-blog-main" data-aos="fade-up" key={blog.slug || i}>
                <Link to={`/blog/${encodeURIComponent(blog.slug)}`}>
                  <img
                    src={blog.image}
                    alt={blog.title}
                    width={550}
                    height={310}
                    style={{ objectFit: "cover" }}
                    onError={(e) =>
                      (e.currentTarget.src = "https://via.placeholder.com/550x310?text=Blog")
                    }
                  />
                </Link>
                <div>
                  <div className="design-date">
                    <p>{blog.category}{blog.author ? ` • by ${blog.author}` : ""}</p>
                    <p>{blog.date ? blog.date.toLocaleDateString() : ""}</p>
                  </div>
                  <Link to={`/blog/${encodeURIComponent(blog.slug)}`} style={{ textDecoration: "none" }}>
                    <p className="steps">{blog.title}</p>
                  </Link>
                  <p className="pursuing">{blog.excerpt}</p>
                  <p className="explore-me p-0">
                    <Link to={`/blog/${encodeURIComponent(blog.slug)}`}>
                      Read More
                      <svg className="expo-arrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path d="M6.66669 16H25.3334" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M20 21.3333L25.3333 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M20 10.6666L25.3333 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </Link>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <BrandsMarqueSection />
        <TextMarqueSection />
        <Footer />
        <ProgressCircle />
      </div>
    </>
  );
};

export default BlogSeven;
